module.exports = __webpack_public_path__ + "img/ep1-2.a74d5560.jpg";